<template>
  <v-row align="center" justify="center">
    <v-overlay :absolute="true" color="black" opacity=0.6 value="true" z-index=-0>
      <v-card width="420" class="pa-6" light>
        <v-card-title>Choisir votre mot de passe</v-card-title>

        <v-card-text v-if="done">
          <v-alert type="success" dense>Votre mot de passe est enregistré.</v-alert>
          <template v-if="forApp && isPhone">Retournez dans l'application AskMe et connectez-vous avec votre nouveau mot de passe.</template>
          <template v-else-if="forApp">Connectez-vous dans l'application AskMe sur votre téléphone avec votre nouveau mot de passe.</template>
          <template v-else>Vous pouvez maintenant vous connecter.</template>
        </v-card-text>

        <v-card-text v-else-if="!token">
          <v-alert type="error" dense>Ce lien est incomplet.</v-alert>
          Refaites une demande avec « Mot de passe oublié ? » sur l'écran de connexion{{ forApp ? ' de l\'application' : '' }}.
        </v-card-text>

        <v-card-text v-else>
          <v-form ref="form" v-model="isValid" @submit.prevent="onSubmit">
            <v-text-field
              v-model="password1"
              :type="show ? 'text' : 'password'"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[v => !!v || 'Mot de passe obligatoire', v => (v || '').length >= 8 || '8 caractères minimum', v => v !== 'welcome' || 'Mot de passe interdit']"
              label="Nouveau mot de passe"
              autocomplete="new-password"
              @click:append="show = !show"
            ></v-text-field>
            <v-text-field
              v-model="password2"
              :type="show ? 'text' : 'password'"
              :rules="[v => v === password1 || 'Mot de passe différent']"
              label="Répétition du mot de passe"
              autocomplete="new-password"
            ></v-text-field>
            <v-alert v-if="errorMessage" type="error" dense class="mt-2">{{ errorMessage }}</v-alert>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Compte de l'application : jamais vers la connexion du back-office ; sur téléphone, retour dans l'application -->
          <v-btn v-if="(done || !token) && forApp && isPhone" color="primary" href="askme://login">Ouvrir l'application</v-btn>
          <v-btn v-else-if="(done || !token) && !forApp" color="primary" @click="$router.push('/')">Se connecter</v-btn>
          <v-btn v-else-if="token && !done" color="primary" :loading="isSending" :disabled="!isValid || password1.length < 8 || password1 !== password2" @click="onSubmit">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import sha1 from 'sha1'

// Page publique ouverte depuis le lien reçu par e-mail : lien à usage unique et limité dans le temps (SEC-24)
export default {
  name: 'ResetPassword',
  data: () => ({
    password1: '',
    password2: '',
    show: false,
    isValid: false,
    isSending: false,
    done: false,
    errorMessage: ''
  }),
  computed: {
    // Lien demandé depuis l'application, ou compte collaborateur (sans accès au back-office)
    forApp: function() {
      return this.$route.query.app === '1'
    },
    isPhone: function() {
      return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    token: function() {
      const token = this.$route.query.token
      return typeof token === 'string' && /^[0-9a-f]{64}$/.test(token) ? token : ''
    }
  },
  methods: {
    onSubmit: function() {
      if (!this.token || this.password1.length < 8 || this.password1 !== this.password2) return
      this.isSending = true
      this.errorMessage = ''
      this.$http.post('passwordreset', { token: this.token, password: sha1(this.password1) })
        .then(() => {
          this.done = true
        })
        .catch(error => {
          const status = error.response && error.response.status
          this.errorMessage = status === 410
            ? `Ce lien a expiré ou a déjà servi. Refaites une demande avec « Mot de passe oublié ? »${this.forApp ? ' dans l\'application' : ''}.`
            : 'Le mot de passe n\'a pas pu être enregistré. Réessayez plus tard.'
        })
        .finally(() => {
          this.isSending = false
        })
    }
  }
}
</script>
